export const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6692633734';
export const ANDROID_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.charlietech.xyz.hmonglus';
